import { CreatorSegment, SegmentJoint } from '@/types/creator';
import { WritableDraft } from '@reduxjs/toolkit';
import RENDERER_CONFIG from '@/configs/rendererConfig';
import ConfigurationRenderer from '../ConfigurationRenderer';
import DrawableObject from './DrawableObject';
import RollerBox from './RollerBox';
import Window from './Window';

class Segment extends DrawableObject {
	static readonly DIVISION_WIDTH = 15;
	prevJoint?: SegmentJoint;
	nextJoint?: SegmentJoint;
	isArmorError = false;
	rollerBox: RollerBox;
	window: Window;

	constructor(
		renderer: ConfigurationRenderer,
		prevJoint?: SegmentJoint,
		nextJoint?: SegmentJoint
	) {
		super(renderer);

		this.container.zIndex = RENDERER_CONFIG.SEGMENT.Z_INDEX;
		this.renderer.configuration.addChild(this.container);
		this.prevJoint = prevJoint;
		this.nextJoint = nextJoint;
		this.rollerBox = new RollerBox(renderer, prevJoint, nextJoint);
		this.container.addChild(this.rollerBox.container);

		this.window = new Window(renderer);
		this.container.addChild(this.window.container);
	}

	draw() {
		this.rollerBox.draw();
		this.window.draw();
	}

	setFromCreatorSegment(state: WritableDraft<CreatorSegment>) {
		this.id = state.id;
		this.isArmorError = state.isArmorError;

		const rollerBoxHeight = this.renderer.manager.rollerBoxHeight;

		this.dimensions = {
			width: state.width,
			height: rollerBoxHeight + state.window.height,
		};
		this.scaledDimensions = {
			width: this.dimensions.width * this.renderer.scale,
			height: this.dimensions.height * this.renderer.scale,
		};

		this.rollerBox.dimensions = {
			width: state.width,
			height: rollerBoxHeight,
		};
		this.rollerBox.scaledDimensions = {
			width: this.rollerBox.dimensions.width * this.renderer.scale,
			height: this.rollerBox.dimensions.height * this.renderer.scale,
		};
		this.rollerBox.id = state.rollerBox.id;

		this.window.dimensions = {
			width: state.width,
			height: state.window.height,
		};
		this.window.scaledDimensions = {
			width: this.window.dimensions.width * this.renderer.scale,
			height: this.window.dimensions.height * this.renderer.scale,
		};

		this.window.setWingsFromCreatorState(
			state.window.wings,
			state.window.wingDivisions
		);
		this.window.id = state.window.id;
	}

	override destroy() {
		this.window.destroy();
		super.destroy();
	}
}

export default Segment;
